/** Clave de sesión de usuario (compartida con header cuando exista login API). */
export const MEGA_AUTH_STORAGE_KEY = 'mega_usuario';
